export default "__VITE_ASSET__e12517fc__"